<template>
  <div class="text-center">
    <v-navigation-drawer
      app
      v-model="drawer"
      absolute
      bottom
      right
      style="box-shadow: 0 0 0 0, 0 0 0 0 , 0 0 0 0;"
      temporary
    >
      <v-card elevation="0">
        <v-card-text class="text-uppercase">Exportar relatórios</v-card-text>
        <v-card-text class="text-uppercase">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-left="60"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date1"
                label="Data Inicial"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date1"
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-card-text>

        <v-card-text class="text-uppercase">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-left="60"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Data Final"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-text class="">
          <v-btn depressed block @click="exportCsv">
            <v-icon class="mx-2">mdi-file-delimited</v-icon>Exportar em CSV
          </v-btn>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import eventBus from "@/main";
import jwtDecode from "jwt-decode";

export default {
  name: "OpenDialogExportReport",
  data: () => ({
    dialog: false,
    drawer: false,

    date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),

    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    modal: false,
    menu1: false,
    menu2: false
  }),
  methods: {
    exportCsv() {
      const userToken = localStorage.getItem("token");
      const decode = jwtDecode(userToken);
      const payload = {
        entityUUID: decode.CA,
        dateFrom: this.date1,
        dateTo: this.date2
      };
      this.$store.dispatch("getExportCsv", payload);
    }
  },
  created() {
    const self = this;
    eventBus.$on("openDialogExportReport", function(value) {
      self.dialog = value.dialog;
      self.drawer = value.drawer;
    });
  }
};
</script>

<style scoped></style>
